import { resolveRenderer } from './resolveRenderer'

// Renderer components and primitives are imported directly from their own
// modules (./renderers, ./primitives). The renderer-resolution logic lives in
// ./resolveRenderer so this module can export only the ToolResultRenderer
// component (react-refresh/only-export-components).

/**
 * Main component that renders tool call results.
 * Automatically selects the best renderer based on tool name and data structure.
 */
export function ToolResultRenderer({
  toolName,
  data,
  success,
}: {
  toolName: string
  data: unknown
  success?: boolean
}) {
  const Renderer = resolveRenderer(toolName, data, success)
  return <Renderer data={data} />
}
